import { render, staticRenderFns } from "./TheNavbar.vue?vue&type=template&id=4654bc32&scoped=true"
import script from "./TheNavbar.vue?vue&type=script&lang=js"
export * from "./TheNavbar.vue?vue&type=script&lang=js"
import style0 from "./TheNavbar.vue?vue&type=style&index=0&id=4654bc32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654bc32",
  null
  
)

export default component.exports